import React, {useEffect, useReducer, useState} from 'react';
import {getHundByBevisId, getHundOgLeggTilSisteHunder, getHundProfilBilde, postForm} from '../api';
import Hund from "../components/Hund";



import qs from "query-string";
import StamtavleContainer from "./StamtavleContainer";
import UtstillingerContainer from "./UtstillingerContainer";
import ProeverContainer from "./ProeverContainer";
import SunnhetAdferdStatistikkContainer from "./SunnhetAdferdStatistikkContainer";
import KullOppdretterContainer from "./KullOppdretterContainer";
import Error from "../components/Error";
import ErrorTekst from "../components/ErrorTekst";


const HundContainer = (props) => {
    const sisteHunder = props.sisteHunder || [];
    const favoritter = props.favoritter || [];
    const parsed = qs.parse(decodeURI(props.location.search));
    const hundId = parsed.id != undefined ?  parsed.id : null;
    const { id } = props.match.params;

    const personId = props.personIdGyldigBruker || null;
    const [count, forceUpdate] = useReducer(x => x + 1, 0);
    const {hund, isHundLoading, errorHundText} = useFetchHund(hundId, id);
    const {bilde} = useFetchHundProfilBilde(hund !== null ? hund.hundId : null, count, id);

    const favoritt = favoritter.some(item => item.hundId === hundId);

    useEffect(() => {
        if (hund != null) {
            props.hundIdGetter(hund.hundId);
        }
    }, [hund]);



    const setFavorittStatus = (favoritt) =>  {
        var action = 'fjernFavorittHund';
        if (favoritt) action = 'leggTilFavorittHund';
        const formdata = new FormData();
        formdata.append('hundId', hund.hundId);
        postForm(action, formdata)
            .then((data)=>{
                props.reLoadFavoritter();
            })
            .catch((err)=> {
                console.log(err);
            });
    };

    const reloadBilde = () => {
        forceUpdate();
    };

    //console.log(bilde);
    return (
        <div>
            { isHundLoading && <div className='loading-screen'><div className='loader'></div></div> }
            { errorHundText !== null && id === null  && errorHundText !== 403 && hund === null && <div>{hundId} finnes ikke </div>}
            { errorHundText !== null && id !== null && errorHundText !== 403 && hund === null && <div>Finnes ingen stambogcerfikat eller ejerbevis med id: {id} </div>}
            { errorHundText === 403  &&
                <Error>
                    <ErrorTekst errorCode={errorHundText} search={true}/>
                </Error>
            }
            { hund !== null && errorHundText === null &&

                <div>
                    <Hund hund={hund} profilBilde={bilde} personId={personId} favoritt={favoritt} updateFavorittStatus={setFavorittStatus} reloadBilde={reloadBilde}  />
                    <StamtavleContainer hund={hund} sisteHunder={sisteHunder} favoritter={favoritter} />
                    <UtstillingerContainer hund={hund} />
                    <ProeverContainer hund={hund} />
                    <SunnhetAdferdStatistikkContainer hund={hund} />
                    <KullOppdretterContainer hund={hund} personId={personId} />

                </div>
            }

        </div>
    );
};


const useFetchHund = (id, bevisId) => {
    const [hund, setHund] = useState(null);
    const [isHundLoading, setIsHundLoading] = useState(false);
    const [errorHundText, setErrorHundText] = useState(null);
    useEffect(() => {
        let isMounted = true;
        const fetchHundDataByHundId = () => {
            if (isMounted) {
                setIsHundLoading(true);
                setErrorHundText(null);
            }
            getHundOgLeggTilSisteHunder(id)
                .then((hund) => {
                    if (isMounted) {
                        setHund(hund);
                        setIsHundLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsHundLoading(false);
                        if (err.message === '403') {
                            setErrorHundText(403);
                        } else {
                            setErrorHundText(err.message);
                        }
                    }
                });
        };
        const fetchHundDataByBevisId = () => {
            if (isMounted) {
                setIsHundLoading(true);
                setErrorHundText(null);
            }
            getHundByBevisId(bevisId)
                .then((hund) => {
                    if (isMounted) {
                        setHund(hund);
                        setIsHundLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsHundLoading(false);
                        if (err.message === '403') {
                            setErrorHundText(403);
                        } else {
                            setErrorHundText(err.message);
                        }
                    }
                });
        };
       if (bevisId != null) {
            fetchHundDataByBevisId();
        } else {
            if (id != null) {
                fetchHundDataByHundId();
            }
        }

        return () => {
            isMounted = false;
        };
    }, [id, bevisId]);

    return { hund, isHundLoading, errorHundText };
};

const useFetchHundProfilBilde = (hundId, count, id) => {
    const [bilde, setBilde] = useState(null);
    const [isBildeLoading, setIsBildeLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsBildeLoading(true);
            }

            getHundProfilBilde(hundId, id)
                .then((bilde) => {
                    if (isMounted) {

                        setBilde(bilde);
                        setIsBildeLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setBilde(null);
                        setIsBildeLoading(false);
                    }
                });
        };
        if (hundId !== null) {
            fetchData();
        }

        return () => {
            isMounted = false;
        };
    }, [hundId, count, id]);

    return { bilde, isBildeLoading };
}


export default HundContainer;
